import React from 'react';
import { Link } from 'react-router-dom';
import './CaseStudyCard.css';

/**
 * 成功案例卡片组件
 * @param {string} clientName - 客户名称
 * @param {string} industry - 行业
 * @param {string} challenge - 挑战描述
 * @param {Array} results - 关键成果列表
 * @param {string} image - 封面图片URL
 * @param {string} slug - 案例slug
 * @param {boolean} featured - 是否为精选案例
 * @param {string} featuredLabel - 精选标签文本
 * @param {string} keyResultsLabel - "关键成果"标签文本
 * @param {string} readMoreLabel - "了解更多"按钮文本
 */
const CaseStudyCard = React.memo(({ 
  clientName,
  industry,
  challenge,
  results,
  image,
  slug,
  featured = false,
  featuredLabel = '精选',
  keyResultsLabel = '关键成果',
  readMoreLabel = '了解更多'
}) => {
  return (
    <a 
      href={`/case-studies/${slug}`} 
      className="case-study-card"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="case-study-content">
        <span className="case-study-industry">{industry}</span>
        <h3 className="case-study-title">{clientName}</h3>
        <p className="case-study-challenge">{challenge}</p>
        
        {results && results.length > 0 && (
          <div className="case-study-results">
            <strong className="results-label">{keyResultsLabel}</strong>
            <ul className="results-list">
              {results.slice(0, featured ? 4 : 2).map((result, index) => (
                <li key={index}>{result}</li>
              ))}
            </ul>
          </div>
        )}
        
        <span className="case-study-link">
          {readMoreLabel} →
        </span>
      </div>
    </a>
  );
});

CaseStudyCard.displayName = 'CaseStudyCard';

export default CaseStudyCard;
